export const ADD_TO_FEATURE_FLAG_LIST = 'ADD_TO_FEATURE_FLAG_LIST';
export const REMOVE_FORM_FEATURE_FLAG_LIST = 'REMOVE_FORM_FEATURE_FLAG_LIST';